import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconBookmarkActiveSvg } from "./IconBookmarkActiveSvg.mjs";
import { IconBookmarkSvg } from "./IconBookmarkSvg.mjs";
const IconBookmark = ({
  active = false,
  ...props
}) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(
  Box,
  {
    component: active ? IconBookmarkActiveSvg : IconBookmarkSvg,
    ...svgProps
  }
) });
export {
  IconBookmark
};
